import React, { useEffect } from 'react';
import { setCleanInputError } from '../../../../utils/utils';

import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import InputButtonFile from '../../../../components/inputs/InputButtonFile';
import { GuideDataForm } from '../../../../app/models/Guide';
import { DispatchProgramItemWithTransportOrder } from '../../../../app/models/DispatchProgramItem';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Unit } from '../../../../app/models/Unit';

interface DispatchProgramItemProps {
    dispatchProgramWithTransportOrderDataForm: DispatchProgramItemWithTransportOrder;
    setGuide: (guide: GuideDataForm) => void;
    guide: GuideDataForm;
    units: Unit[];
    errorFields?: any;
}

const DispatchProgramItemGuideForm = ({
    dispatchProgramWithTransportOrderDataForm,
    setGuide,
    guide,
    units,
    errorFields,
}: DispatchProgramItemProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChangeDocumentFile = (e: FileList | null, type: string) => {
        if (e) {
            setGuide({ ...guide, ['file']: e[0] });
        }
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
       
        setGuide({ ...guide, [name]: value });
    };

    const handleRemoveFile = () => {
        setGuide({
            ...guide,
            ['file']: undefined
        });
        const fileInput = document.getElementById('file') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };
        if (name === 'total_unit_id') {
            obj['tara_total_unit_id'] = value;
        }
        setGuide({ ...guide, ...obj });
    };

    return (
        <>
            <h5 className="mb-3">Datos Guia</h5>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Archivo</label>

                <div className="col-md-9">
                    <InputButtonFile
                        handleChangeDocumentFile={handleChangeDocumentFile}
                        handleRemoveFile={handleRemoveFile}
                        name={'file'}
                        objectFile={guide?.file}
                        disabled={dispatchProgramWithTransportOrderDataForm.is_internal}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('file')}
                    </div>
                </div>
                <label className="col-md-3 col-form-label">Folio Guia</label>
                <div className="col-md-9">
                    <input
                        className={`form-control ${fieldHasError('folio')}`}
                        name="folio"
                        id="folio"
                        type="text"
                        value={guide.folio}
                        onChange={handleChange}
                        placeholder="Ingrese el folio de la guia de despacho"
                        onFocus={() => onFocusRemove('folio')}
                        disabled={dispatchProgramWithTransportOrderDataForm.is_internal}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('folio')}
                    </div>
                </div>
                <label className="col-md-3 col-form-label">Neto Guia</label>
                <div className="col-9">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                className={`form-control ${fieldHasError('quantity')}`}
                                name="quantity"
                                id="quantity"
                                type="number"
                                value={guide.quantity}
                                onChange={handleChange}
                                placeholder="Ingrese el total neto de la guia de despacho"
                                onFocus={() => onFocusRemove('quantity')}
                                disabled={dispatchProgramWithTransportOrderDataForm.is_internal}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('quantity')}
                            </div>
                        </div>
                        <div className="col-6">
                            <SelectTwo
                                name="unit_id"
                                id="unit_id"
                                hasError={fieldHasError('unit_id') !== ''}
                                inputValue={guide.unit_id}
                                options={SelectTwoMapperOptions(units)}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('unit_id', value.value)
                                }
                                placeholder={'Unidad'}
                                onFocus={() => onFocusRemove('unit_id')}
                                disabled={dispatchProgramWithTransportOrderDataForm.is_internal}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('unit_id')}
                            </div>
                        </div>
                    </div>
                </div>
                
                <label className="col-md-3 col-form-label">Fecha de emisión</label>
                <div className="col-md-9">
                    <input
                        className={`form-control ${fieldHasError('issue_date')}`}
                        name="issue_date"
                        id="issue_date"
                        type="date"
                        value={guide.issue_date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('issue_date')}
                        disabled={dispatchProgramWithTransportOrderDataForm.is_internal}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('issue_date')}
                    </div>
                </div>

            </div>
        </>
    );
};

export default DispatchProgramItemGuideForm;
